import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

// get request function
const getFunction = async (url, type, errorType, dispatch) => {
  try {
    const getRequestSuccess = await axios.get(url);
    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: data
    });
  } catch (getRequestError) {
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };
    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

// query loading
const setQueryLoading = (data) => (dispatch) => {
  dispatch({
    type: types.QueryTypes.QUERY_SET_CREATE_LOADING,
    payload: data
  });
};

const setCommentLoading = (data) => (dispatch) => {
  dispatch({
    type: types.QueryTypes.COMMENT_SET_CREATE_LOADING,
    payload: data
  });
};

// clear result
const clearQueryResult = () => (dispatch) => {
  dispatch({
    type: types.QueryTypes.QUERY_CLEAR_RESULT
  });
};

// clear error
const clearQueryErrors = () => (dispatch) => {
  dispatch({
    type: types.QueryTypes.QUERY_CLEAR_ERRORS
  });
};

// add queries
const addAndEditQuery = (queryData, queryId, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const url = `${baseUrlNode}${api.Query_Api.ADD_QUERY_API}/${queryId}/${loginType}`;
    const addQuerySuccess = await axios.post(url, queryData);
    dispatch({
      type: types.QueryTypes.ADD_QUERY,
      payload: addQuerySuccess.data
    });
  } catch (queryError) {
    const errorData = {
      data: queryError.response.data,
      status: queryError.response.status
    };
    dispatch({
      type: types.QueryTypes.QUERY_ERRORS,
      payload: errorData
    });
  }
};

// get all queries
const getAllQueries = (
  dataTypes,
  date,
  locationId,
  loginType
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Query_Api.GET_ALL_QUERIES_API}/${date}/${locationId}/${dataTypes}/${loginType}`;
  const type = types.QueryTypes.GET_ALL_QUERIES;
  const errorType = types.QueryTypes.QUERY_ERRORS;
  dispatch({
    type: types.QueryTypes.ALL_QUERY_INPUTS,
    payload: {
      queryDataTypes: dataTypes,
      queryDate: date,
      queryLocation: locationId
    }
  });
  getFunction(url, type, errorType, dispatch);
};

// get query from Id
const getQueryDetails = (queryId, loginType) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Query_Api.GET_QUERY_DETAILS_API}/${queryId}/${loginType}`;
  const type = types.QueryTypes.GET_QUERY_DETAILS;
  const errorType = types.QueryTypes.QUERY_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

// add new comment
const addQueryComment = (commentData, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const url = `${baseUrlNode}${api.Query_Api.ADD_QUERY_COMMENT_API}/${loginType}`;
    const addQuerySuccess = await axios.post(url, commentData);
    dispatch({
      type: types.QueryTypes.ADD_QUERY_COMMENT,
      payload: addQuerySuccess.data
    });
  } catch (queryError) {
    const errorData = {
      data: queryError.response.data,
      status: queryError.response.status
    };
    dispatch({
      type: types.QueryTypes.QUERY_ERRORS,
      payload: errorData
    });
  }
};

export {
  addAndEditQuery,
  getAllQueries,
  getQueryDetails,
  addQueryComment,
  setQueryLoading,
  clearQueryErrors,
  clearQueryResult,
  setCommentLoading
};
